/*
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-20 15:51:16
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-01-11 14:46:43
 */
const plan = [
    {
      path: '/plan/list',
      name: 'pickupList',
      component: () => import('../views/plan/list.vue'),
    },
    {
        path: '/plan/search/list',
        name: 'pickupSearch',
        component: () => import('../views/plan/search-plan.vue'),
    },
    {
        path: '/plan/detail/:id',
        name: 'pickupDetail',
        component: () => import('../views/plan/detail.vue'),
    },
  ]
  export default plan


// WEBPACK FOOTER //
// ./src/router/plan.js